import { render, staticRenderFns } from "./SelectAssistant.vue?vue&type=template&id=bda5e11e&scoped=true&lang=pug"
import script from "./SelectAssistant.vue?vue&type=script&lang=js"
export * from "./SelectAssistant.vue?vue&type=script&lang=js"
import style0 from "./SelectAssistant.vue?vue&type=style&index=0&id=bda5e11e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda5e11e",
  null
  
)

export default component.exports